export const smallPageSize = 5;
export const largePageSize = 25;
export const maxPageSize = 1000;
